var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlotoLink',_vm._b({staticClass:"back-button",attrs:{"id":"main-content","aria-label":_vm.$t('back')}},'FlotoLink',_vm.$attrs,false),[_c('MIcon',{staticStyle:{"position":"unset"},attrs:{"name":`chevron-${_vm.isRtl ? 'right' : 'left'}`,"size":"lg"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }